export default __webpack_public_path__ + "static/media/Standard21.76ec9f26.png";